import { useState } from "react";
import { useAvtovazRequisites } from "./useAvtovazRequisites";

export const useDeleteRequisites = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState(null);
  const { deleteAvtovazRequisite } = useAvtovazRequisites();

  const mutate = async (id: number) => {
    setIsLoading(true);
    setError(null);
    try {
      await deleteAvtovazRequisite(id);
      setIsSuccess(true);
    } catch (error) {
      setError("Ошибка удаления реквизитов");
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, error, mutate, isSuccess };
};
